
export const FRONTEND = `https://liquidip.fruitfulsource.org`
export const API = `https://liquidip.fruitfulsource.org/node`
//export const API = `http://liquidip-alb-be-451913672.us-east-1.elb.amazonaws.com:8080`
//export const API = `http://localhost:3333`

export const request = async (url: string, method: string, extra?: {
    isText?: boolean
    formData?: boolean
    [key: string]: any
}): Promise<any> => {
    try {
        const token = extra?.token
        const headers: any = {
        //'Access-Control-Allow-Origin': '*'
        }
        if (!extra?.formData) {
            headers['Content-Type'] = 'application/json'
        }
        if (token) {
            headers['extra-token'] = token
        }
        const response = await fetch(url + '?' + new URLSearchParams(extra?.query ?? {}), {
            method,
            body: extra?.data ?? undefined,
            headers,
        })
        let ret: string | object = ''
        if (extra?.isText)
            ret = await response.text()
        else
            ret = await response.json()

        if (response.status >= 400) {
            if (typeof ret == 'object') {
                console.error(ret)
                throw new Error('message' in ret ? ret.message as string : JSON.stringify(ret))
            }
            throw new Error(ret)
        }
        return ret
    } catch (err) {
        console.error(err)
        throw err
    }
}

